import * as PIXI from "pixi.js";
import TextureManager from "../../managers/TextureManager";


const STRING_ASSTS_PATH = "./images/string/string_sprite_sheet.png";

const WIDTH = 70;
const HEIGHT = 50;

export default class String extends PIXI.Container {

  textures: PIXI.Texture<any>[] = [];
  string: PIXI.Sprite;
  animString: PIXI.AnimatedSprite;
  constructor() {
    super();
    this.generateTextures();
    this.generateAnimatedString();
  }
  generateTextures() {
    const frameWidth = 287;
    const frameHeight = 199;
    const totalFrame = 80;
    const colums = 5;
    const texture = TextureManager.getTexture(STRING_ASSTS_PATH) as any;
    for (let i = 0; i < totalFrame; i++) {
      const x = (i % colums) * frameWidth;
      const y = Math.floor(i / colums) * frameHeight;
      const rect = new PIXI.Rectangle(x, y, frameWidth, frameHeight)
      const frame = new PIXI.Texture({ source: texture, frame: rect })
      this.textures.push(frame);
    }
  }
  destroyString() {
    this.removeChild(this.string);
    this.string.destroy();
  }
  generateAnimatedString() {
    this.animString = new PIXI.AnimatedSprite(this.textures);
    this.animString.x = 0;
    this.animString.y = 45;
    this.animString.width = WIDTH;
    this.animString.height = HEIGHT;
    this.animString.loop = false;
    this.animString.anchor.set(.9, .5);
    this.addChild(this.animString);
  }
  runAnimation(cb: () => void) {
    this.animString.play();
    this.animString.onComplete = () => cb();
  }
}